import { render, staticRenderFns } from "./Risiko.vue?vue&type=template&id=aeac8bc4&"
import script from "./Risiko.vue?vue&type=script&lang=js&"
export * from "./Risiko.vue?vue&type=script&lang=js&"
import style0 from "./Risiko.vue?vue&type=style&index=0&id=aeac8bc4&prod&lang=css&"
import style1 from "./Risiko.scss?vue&type=style&index=1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports